import { initRunningLine } from "../main/utils/running-line.js";

$(window).on("load", function () {
  var $wrapper = $(".introduction__swiper");

  $wrapper.find("img[data-src]").each(function () {
    var $img = $(this);
    $img
      .attr("src", $img.attr("data-src"))
      .removeAttr("data-src")
      .removeClass("MJ__lazyload");
  });

  var slideCount = $wrapper.find(".swiper-introduction .swiper-slide").length;

  try {
    var mainSwiper = new Swiper($wrapper.find(".swiper-introduction")[0], {
      slidesPerView: 1,
      loop: slideCount > 1,
      centeredSlides: true,
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 500,
        depth: 0,
        modifier: 1,
        scale: 1.1,
        slideShadows: false,
      },
      slideToClickedSlide: true,
      navigation: {
        nextEl: $wrapper.find(".swiper-button-next")[0],
        prevEl: $wrapper.find(".swiper-button-prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: slideCount >= 3 ? 3 : 1,
        },
      },
      on: {
        slideChange: function () {
          var index = this.realIndex;
          $(".introduction__tab--item").removeClass("active");
          $(".introduction__tab--item").eq(index).addClass("active");
        },
      },
    });

    $(document).on("click", ".introduction__tab--item", function (e) {
      e.preventDefault();
      var index = $(".introduction__tab--item").index(this);
      mainSwiper.slideToLoop(index);
    });
  } catch (e) {}

  initRunningLine({
    rootSelector: "#ovensmash-introduction .line__runing",
  });
});
